import React from "react";
import { Empty, Spin } from "antd";
import { ModalProps } from "antd/lib/modal/Modal";
import useRequest from "utils/useRequest";
import BriefInfo from "../../../BriefInfo";
import styles from "./index.module.scss";
import { questionnairePublishResume } from "../../../../../../../service/question";

interface ViewLogModalProps extends ModalProps {
    id: number;
}

export default function ViewLog({ id }: ViewLogModalProps) {
    const [data, { loading }] = useRequest(() =>
        questionnairePublishResume(id)
    );

    return (
        <Spin spinning={loading}>
            {data?.map(item => (
                <div key={item.startTime} className={styles.item}>
                    <BriefInfo {...item} />
                </div>
            ))}

            {data?.length === 0 && <Empty description="没有发布履历" />}
        </Spin>
    );
}
